interface CurrentPath {
    key: string;
    value: object;
    parent: CurrentPath | null;
    data: Record<PropertyKey, unknown>;
}

class Sanitizer<T extends object> {
    obj: T;
    copy: T;
    currentPath: CurrentPath;

    constructor(obj: T) {
        this.obj = obj;
        this.copy = {} as T;

        this.currentPath = {
            key: '',
            value: obj,
            parent: null,
            data: this.copy as Record<PropertyKey, unknown>,
        };
    }

    sanitize(): T {
        const sanitizer = this;

        JSON.stringify(this.obj, function (key, value) {
            if (key === '') {
                return value;
            }

            const parent = this;
            if (parent !== sanitizer.currentPath.value) {
                sanitizer.exit(parent);
            }
            if (typeof value === 'object' && value !== null) {
                sanitizer.enter(key, value);
                return value;
            }
            sanitizer.currentPath.data[key] = value;

            return value;
        });

        return this.copy;
    }

    private enter(key: string, value: object) {
        const { currentPath: parentPath } = this;
        const data: Record<PropertyKey, unknown> = (parentPath.data[key] = (
            Array.isArray(value) ? [] : {}
        ) as Record<PropertyKey, unknown>);
        this.currentPath = {
            key,
            value,
            parent: parentPath,
            data,
        };
    }

    private exit(parent: object) {
        while (this.currentPath.value !== parent) {
            this.currentPath = this.currentPath.parent || this.currentPath;
        }
    }
}

/**
 * Returns a sanitized version of an object by recursively unwrapping the Proxies.
 *
 * All the data coming from LWC-land need to be sanitized first.
 */
export default function sanitize<T extends object>(obj: T): T {
    return new Sanitizer(obj).sanitize();
}
